let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fMM0W")).then(() => parcelRequire('2e3Ru'));